export function abbreviateId(id: string): string {
  return id.slice(0, 8);
}
